<template>
  <button
    type="button"
    @click="getOnClick"
    :aria-label="!onClick ? 'none' : `View details for ${chemical.chemId ?? 'chemical'}`"
    :class="{ 'cursor-default': !onClick }"
  >
    <div style="display: inline-block; position: relative">
      <img
        :id="chemical.chemId"
        :src="`${apiUrl}/render?smiles=${encodeURIComponent(chemical.smiles)}`"
        alt=""
        style="width: 150px; height: 150px"
      />
      <ChemPopover
        v-if="source !== 'alerts'"
        :chemical="chemical"
        :target="chemical.chemId"
        :source="source"
      />
      <v-icon
        v-if="isInDSSTox"
        class="top-right"
        color="green"
      >
        mdi-database-check
      </v-icon>
    </div>
    <div
      v-if="showDetails"
      style="font-size: smaller"
    >
      <div
        v-for="prop in ['name', 'casrn', 'sid', 'cid', 'inchi', 'inchiKey', 'smiles', 'canonicalSmiles']"
        :key="`org-${prop}`"
        class="ml-1 mb-1"
      >
        <span :title="prop">{{ chemical[prop] }}</span>
      </div>
    </div>
  </button>
</template>

<script>
import ChemPopover from '@/components/chemical/ChemPopover/ChemPopover.vue'

export default {
  components: { ChemPopover },
  props: {
    chemical: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: null,
    },
  },
  computed: {
    isInDSSTox() {
      return this.chemical.cid || this.chemical.sid || this.chemical.name || this.chemical.casrn
    },
  },
  methods: {
    getOnClick() {
      if (this.onClick) this.onClick()
    },
  },
}
</script>
<style scoped>
.cursor-default {
  cursor: default !important;
}
</style>
